import axios from "axios";

import SessionStorageUtils from "utils/sessionStorage";
import ResponseManager from "helpers/responseManager";

const axiosInstance = axios.create();
axiosInstance.defaults.withCredentials = true;

// Function that is executed before the request
axiosInstance.interceptors.request.use(
	(requestConfigs) => {
		const authData = SessionStorageUtils.get("player");

		if (!authData) {
			return requestConfigs;
		}

		if (!requestConfigs.headers.authorization) {
			requestConfigs.headers.authorization = "Bearer " + authData.token;
		}

		return requestConfigs;
	},
	(error) => Promise.reject(error)
);

// Function that is executed after the request completes
axiosInstance.interceptors.response.use(
	(response) => {
		return ResponseManager.instance.processSuccess(response)
	},
	(error) => {
		return ResponseManager.instance.processError(error)
	}
)


export default axiosInstance;
